import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import BasicTable from "../../components/UiComponent/customTable";
import {
  get_project_job,
  RegisterProjectJob,
  UpdateProjectJob,
} from "../../services/projectApi";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { GetUserInfo } from "../../utils/permissionChecker";
import { toast } from "react-toastify";
import { Modal, Row, Form, Col, Button, Spinner } from "react-bootstrap";
import { formatDate } from "../../utils/date_utils";
const ProjectJob = () => {
  const { t } = useTranslation();
  const user = GetUserInfo();
  const currentUser =
    user.employee.first_name + " " + user.employee.father_name;
  const queryClient = useQueryClient();
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => {
    setShowModal(true);
    setFormError("");
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setIsUpdateMode(false);
    setJob("");
    setdescription("");
    setJobId("");
    setweight("");
    setStartDate("");
  };
  const [job, setJob] = useState("");
  const [description, setdescription] = useState("");
  const [weight, setweight] = useState("");
  const [startDate, setStartDate] = useState("");
  const [jobId, setJobId] = useState("");
  const [formError, setFormError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const RegisterProjectJobMutation = useMutation(async (newData) => {
    try {
      let result;
      if (isUpdateMode) {
        result = await UpdateProjectJob(newData);
      } else {
        result = await RegisterProjectJob(newData);
      }
      if (result) {
        queryClient.invalidateQueries("get_all_project_jobs");
        toast.success(result.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        handleCloseModal();
      }
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  });
  const getJobQuery = useQuery(["get_all_project_jobs"], () =>
    get_project_job()
  );

  const jobData = useMemo(() => {
    return getJobQuery.data || [];
  }, [getJobQuery.data]);
  if (getJobQuery.isLoading) {
    return <div>Loading...</div>;
  }
  if (getJobQuery.isError) {
    return <div>Error: {getJobQuery.error.message}</div>;
  }
  const Update = (event, data) => {
    event.preventDefault();
    setJob(data.job_title);
    setdescription(data.description);
    setJobId(data.id);
    setweight(data.weight);
    setIsUpdateMode(true);
    handleShowModal();
  };

  const handleButtonSubmit = async (e) => {
    e.preventDefault();
    let jobData;
    if (!job || !description) {
      setFormError("Pease fill all fields are required ");
      return;
    }
    if (isUpdateMode) {
      jobData = {
        id: jobId,
        job_title: job,
        description,
        weight,
        startDate,
        updated_by: currentUser,
      };
    } else {
      jobData = {
        job_title: job,
        description,
        weight,
        startDate,
        created_by: currentUser,
      };
    }
    try {
      setIsSubmitting(true);
      await RegisterProjectJobMutation.mutate(jobData);
    } finally {
      setIsSubmitting(false);
    }
  };

  const jobColumns = [
    {
      header: "job_title",
      accessorKey: "job_title",
    },
    {
      header: "weight",
      accessorKey: "weight",
    },
    {
      header: "start_date",
      accessorFn: (row) => `${formatDate(row.start_date)} `,
    },
    {
      header: "Action",
      accessor: "id",
      cell: (row) => (
        <div className="d-flex justify-content align-items-center">
          <Button
            variant="btn btn-info btn-sm"
            onClick={(e) => Update(e, row.row.original)}
          >
            {t("update")}
          </Button>
        </div>
      ),
    },
  ];
  return (
    <>
      <BasicTable
        data={jobData}
        columns={jobColumns}
        title={`Task List`}
        actionButton={
          <Button
            variant="btn btn-info btn-sm"
            onClick={() => handleShowModal()}
          >
            {t("add_new_job")}
          </Button>
        }
      />
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title as="h5">
            {isUpdateMode ? "Update the task" : "Register new task"}{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col lg="12">
                <Form.Group>
                  <Form.Label className="text-secondary">Task name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter task name"
                    value={job}
                    onChange={(e) => setJob(e.target.value)}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label className="text-secondary">
                    Task weight
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter task weight"
                    value={weight}
                    onChange={(e) => setweight(e.target.value)}
                  />
                  <p className="text-danger"> {formError}</p>
                </Form.Group>

                <Form.Group>
                  <Form.Label className="text-secondary">
                    Task start date
                  </Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="Enter task start date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                  <p className="text-danger"> {formError}</p>
                </Form.Group>

                <Form.Group>
                  <Form.Label className="text-secondary">
                    Description
                  </Form.Label>

                  <Form.Control
                    as="textarea"
                    id="horizontalTextarea"
                    rows="3"
                    value={description}
                    onChange={(e) => setdescription(e.target.value)}
                    required
                    placeholder="Enter task description"
                  ></Form.Control>
                  <p className="text-danger"> {formError}</p>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          {isSubmitting ? (
            <Button className="btn btn-info">
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              <span className="visually-hidden">Sending...</span>
            </Button>
          ) : (
            <Button
              className="btn btn-info"
              onClick={(e) => handleButtonSubmit(e)}
            >
              {isUpdateMode ? "Update" : "Register"}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProjectJob;
